import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { ResizeInstanceRequestModel } from '../../apis/v1/instances/model';
import { getErrorMessage } from '@xver/utils/error';
import { INSTANCE_LIST_QUERY_KEY } from './useInstanceListQuery';

export function useResizeInstanceMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }: { id: number; data: ResizeInstanceRequestModel }) =>
            Endpoints.v1.Instances.resizeInstance(id, data),
        onSuccess: (_res, vars) => {
            queryClient.invalidateQueries({ queryKey: INSTANCE_LIST_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: ['api.v1.instances.get', vars.id] });
            notifications.show({
                title: t('instance.resizeStartedTitle'),
                message: t('instance.resizeStartedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('instance.resizeFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
